import React from 'react';
import API from '../../configAPI';
import ProductItem from '../product/ProductItem';
import PulseLoader from 'react-spinners/PulseLoader';
import CONFIG from '../../config';
class ProviderDetails extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            provider: {
                products: [],
                phones:[],
                addresses: [],
            },
            subcates: [],
            loading : true,
            current_subcate_id : 0
        }
    }

    componentDidMount(){
        API.PRODUCTS(`provider/${this.props.match.params.provider}`)
        .then(resp =>{
            this.setState({
                provider : resp.data.provider,
                subcates: resp.data.subcates,
                loading: false

            });
        })
        .catch(err =>{
            console.log(err);
        });
        window.scrollTo(0,0);
    }
    getProductsBySubcate = (slug,subcate_id) =>{
        window.event.preventDefault();
        this.setState({
            loading: true,
            current_subcate_id : subcate_id
        });
        console.log(slug);
        API.PRODUCTS(`products/provider/subcategory?slug=${slug}&providerid=${this.state.provider.id}`)
        .then(resp =>{
            this.setState({
                provider : {
                    ...this.state.provider,
                    products : resp.data
                },
                loading: false

            });
        })
        .catch(err =>{
            console.log(err);
        });
    }

    render(){

        return (
            <div>
                <PulseLoader
                    css={CONFIG.spinner_css}
                    size={CONFIG.spinner_size}
                    margin={CONFIG.spinner_margin}
                    color={CONFIG.spinner_color}
                    loading={this.state.loading}
                />
                <div className="portada relativo" style={{backgroundImage: `url(${this.state.provider.url_portada})`}}>
                    <div className="providerbg relativo">
                        <img src={this.state.provider.url_logo} className="absoluto img-fluid img-thumbnail" alt=""/>   
                    </div>
                </div>
                <div className="container-fluid mt-2 mb-2">
                    <div className="col-12 mt-5">
                    <div class="nombre_empresa">
                        <h4>{this.state.provider.name}</h4>
                         <div className="botones_contact">

                                    <a className="button" href={`/empresa-videos/${this.state.provider.slug}`}><i class="far fa-file-video"></i>Videos</a> 
                                    <a className="button" target="_blank" href={this.state.provider.url_web}><i className="fas fa-globe"></i>Sitio Web</a>
                                    <a className="button" href={`mailto:${this.state.provider.assoc_email}`}><i className="fas fa-envelope"></i>Email</a>
                                    <a className="button" href="#more-info" data-toggle="modal"><i className="fas fa-building"></i>Contacto</a>
                         </div>
                    </div>
                        <div className="">
                            <section className="">
                                <div className="mb-4">
                                <h6><strong><span>Información</span> de la empresa:</strong></h6>
                                <div className="descripcion" dangerouslySetInnerHTML={{__html: this.state.provider.description}}>

                                </div>
                                
                                </div>
                                <div className="botones_contact">
                                    <a className="button" target="_blank" href={this.state.provider.url_web}><i class="far fa-file-video"></i>Videos</a> 
                                    <a className="button" target="_blank" href={this.state.provider.url_web}><i className="fas fa-globe"></i>Sitio Web</a>
                                    <a className="button" href={`mailto:${this.state.provider.assoc_email}`}><i className="fas fa-envelope"></i>Email</a>
                                    <a className="button" href="#more-info" data-toggle="modal"><i className="fas fa-building"></i>Contacto</a>
                                </div>
                            </section>
                            <div className="contacto">
                                <div className="datos">
                                {/*<h6><strong>Datos de la Empresa</strong></h6>*/}{/*
                                <div className="">
                                    <div className="iframe">
                                    <a target="_blank"  href={this.state.provider.url_web}><iframe src={this.state.provider.url_web} 
                                    marginwidth="0" marginheight="0"  scrolling="no" border="0" 
                                    frameborder="0" >
                                    </iframe></a>
                                    <div className="botones">
                                    <a href={`tel:${this.state.provider.phone_number}`}><i className="fas fa-phone-volume"></i></a>

                                    <a target="_blank" href={`https://www.google.com/maps/search/${this.state.provider.address}`}><i className="fas fa-map-marker-alt"></i></a>
                                   
                                    <a href={`mailto:${this.state.provider.assoc_email}`}><i className="fas fa-envelope-open-text"></i></a>
                                    </div>
                                    </div>
                                    <div className="botones_contact">
                                    <a className="button" target="_blank" href={´/empresa-videos/´}><i class="far fa-file-video"></i>Videos</a> 
                                    <a className="button" target="_blank" href={this.state.provider.url_web}><i className="fas fa-globe"></i>Sitio Web</a>
                                    <a className="button" href={`mailto:${this.state.provider.assoc_email}`}><i className="fas fa-envelope"></i>Email</a>
                                    <a className="button" href="#more-info" data-toggle="modal"><i className="fas fa-building"></i>Contacto</a>
                                    </div>
                                {/*
                                <a className="bot_contact" target="_blank" rel="noopener noreferrer" href={this.state.provider.url_web}><i className="fas fa-globe fa-2x"></i></a>
                                <a className="bot_contact" href={`mailto:${this.state.provider.assoc_email}`}> <i className="fas fa-envelope fa-2x"></i> </a>
                                <a className="bot_contact" href="#more-info" data-toggle="modal">
                                
                                 


                                    <i className="fas fa-building fa-2x"></i> 
                                </a> 
                                </div>*/}
                                <div className="modal" id="more-info" tabIndex="-1" role="modal">
                                    <div className="modal-dialog modal-md" role="document">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h5 className="modal-title"><i className="fas fa-info-circle"></i> {this.state.provider.name}</h5>
                                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>
                                            <div className="modal-body">
                                                <h2 className="text-center">
                                                    <span className="badge badge-success badge-pill">{this.state.provider.phone_number}</span>
                                                </h2>
                                                {this.state.provider.phones.map((phone,index) => (
                                                    <span key={index} className="badge badge-secondary m-1">{phone.phone_number}</span>
                                                ))}
                                                <hr/>
                                                <h5 className="text-center">
                                                    <span className="badge badge-warning badge-pill">{this.state.provider.assoc_email}</span>
                                                </h5>
                                                <hr/>
                                                <h6 className="text-center">
                                                    {this.state.provider.address}
                                                </h6>
                                                <hr/>
                                                <p className="text-secondary">Otras direcciones</p>
                                                <ul className="list-group">
                                                    {this.state.provider.addresses.map((address, index) =>(
                                                        <li key={index}  title={address.reference} className="list-group-item">{address.name}</li>
                                                    ))}
                                                </ul>
                                            </div>
                                            <div className="modal-footer">

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                </div>
                            </div>

                        </div>
                        
                        <div className="row d-flex flex-wrap mt-3">
                            <section className="col-xs-12 col-md-3 mt-1 mb-1">
                                <div className="list-group">
                                    <li className="list-group-item secondary bg-black"><i className="fas fa-filter"></i> Filtros</li>
                                    {this.state.subcates.map((subcate,index) =>(
                                        <button onClick={() => this.getProductsBySubcate(subcate.slug,subcate.id)} key={index} 
                                        className={`list-group-item d-flex justify-content-between align-items-center list-group-item-action item-menu ${this.state.current_subcate_id === subcate.id ? 'active': ''}`}>
                                        {subcate.name} <span className="badge badge-primary badge-pill">{subcate.products_count}</span>
                                        </button>
                                    ))}
                                </div>
                            </section>
                            <section className="col-xs-12 col-md-9 mt-1 mb-1">
                                <div className="row d-flex flex-wrap">
                                    <ProductItem products={this.state.provider.products}/>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
            
        )
    }
}
export default ProviderDetails;